import React, { useContext } from 'react';
import { Feedback, Text, Button } from 'react-onei';
import { useHistory } from 'react-router';
import UserContext from '../../context/UserContext';
import { WBUTTON_003, WLOST_700, WLOST_701 } from '../../wording';

const ErrorView = ({ title, message, buttonLabel, type }) => {
  let history = useHistory();
  const { serviceConf, wording } = useContext(UserContext);
  const { WBUTTON_005 } = wording;
  let { redirectUrl } = serviceConf;

  if (!redirectUrl) {
    redirectUrl = window.reactAppEnv.orangePortail;
  }

  async function handleClick() {
    if (buttonLabel === WBUTTON_005) {
      history.push('/ident');
    } else {
      window.location.href = redirectUrl;
    }
  };

  return (
    <div>
      <Feedback id="error" variant={type} title={title} className="spacing-s no-spacing-mobile">
        <Text
          id="error-message"
          variant="lead"
        >
          {message}
        </Text>
        <Button id="button-action" onClick={handleClick} className="spacing-s">
          {buttonLabel}
        </Button>
      </Feedback>
    </div>
  );
}

ErrorView.defaultProps = {
  title: WLOST_700,
  message: WLOST_701,
  buttonLabel: WBUTTON_003,
  type: 'error',
}

export default ErrorView;